<template>
  <header class="eds-primary-header">
    <a href="#" class="header-logo" @click.prevent>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 78.8 25.5"
        style="height: 38px; transform: translate(0, 2px)"
      >
        <title>Experian logo</title>
        <path
          d="M12.5 6h-2.9a1.5 1.5 0 0 1-1.6-1.6v-2.9c0-0.8 0.7-1.6 1.6-1.6h2.9c0.8 0 1.6 0.7 1.6 1.6v2.9c0 0.9-0.7 1.6-1.6 1.6"
          style="fill: #406eb3; stroke-width: 0.3"
        />
        <path
          d="M5 12.5h-3.2a1.7 1.7 0 0 1-1.7-1.7v-3.3c0-1 0.8-1.7 1.7-1.7h3.3c1 0 1.7 0.8 1.7 1.7v3.3c0 1-0.8 1.7-1.8 1.7"
          style="fill: #632678; stroke-width: 0.3"
        />
        <path
          d="M4.7 19.2h-2a1.1 1.1 0 0 1-1.1-1.1v-2c0-0.6 0.5-1.1 1.1-1.1h2c0.6 0 1.1 0.5 1.1 1.1v2c0 0.6-0.5 1.1-1.1 1.1"
          style="fill: #982881; stroke-width: 0.3"
        />
        <path
          d="M10 25.5h-2.4a1.3 1.3 0 0 1-1.3-1.3v-2.4c0-0.7 0.6-1.3 1.3-1.3h2.4c0.7 0 1.3 0.6 1.3 1.3v2.4c0 0.7-0.6 1.3-1.3 1.3"
          style="fill: #ba2f7d; stroke-width: 0.3"
        />
        <path
          d="M18.6 7.2h-1.6a0.9 0.9 0 0 1-0.9-0.9v-1.6a0.9 0.9 0 0 1 0.9-0.9h1.6a0.9 0.9 0 0 1 0.9 0.9v1.6c0 0.5-0.4 0.9-0.9 0.9"
          style="fill: #ba2f7d; stroke-width: 0.3"
        />
        <path
          d="M54.2 8.3a0.9 0.9 0 0 0 0.9-0.9 0.9 0.9 0 0 0-0.9-0.9 0.9 0.9 0 0 0-1 0.9c0 0.5 0.4 0.9 1 0.9z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M20 18.3c-0.1 0.2-0.4 0.3-0.6 0.3-0.1 0-0.3 0-0.4-0.1-0.2-0.1-0.3-0.4-0.3-0.7 0-0.1 0-0.3 0.1-0.4l2.2-3.4-2.2-3.4a0.7 0.7 0 0 1-0.1-0.4 0.8 0.8 0 0 1 0.8-0.8c0.3 0 0.5 0.1 0.7 0.3l1.8 2.8 1.8-2.8c0.1-0.2 0.4-0.3 0.7-0.3a0.8 0.8 0 0 1 0.8 0.8 0.6 0.6 0 0 1-0.1 0.4l-2.2 3.4 2.2 3.4c0.1 0.1 0.1 0.2 0.1 0.4 0 0.3-0.1 0.6-0.3 0.7a0.8 0.8 0 0 1-0.4 0.1 0.8 0.8 0 0 1-0.6-0.3l-1.8-2.8z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M27.8 10.5a4.7 4.7 0 0 1 3.1-1.2c2.6 0 4.7 2.1 4.7 4.7 0 2.6-2.1 4.7-4.7 4.7-1.2 0-2.3-0.4-3.1-1.2v4c0 0.4-0.4 0.7-0.8 0.7-0.4 0-0.8-0.3-0.8-0.7v-11.3c0-0.4 0.4-0.7 0.8-0.7 0.4 0 0.8 0.3 0.8 0.7zm3.1 0.4a3.1 3.1 0 0 0-3.1 3.1 3.1 3.1 0 0 0 3.1 3.1 3.1 3.1 0 0 0 3.1-3.1c0-1.7-1.3-3.1-3.1-3.1z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M48.8 13.2v4.7c0 0.4-0.4 0.7-0.8 0.7-0.4 0-0.8-0.3-0.8-0.7v-7.7c0-0.4 0.4-0.7 0.8-0.7 0.4 0 0.7 0.3 0.8 0.7a3.9 3.9 0 0 1 2.3-0.8c0.5 0 0.8 0.4 0.8 0.8 0 0.4-0.4 0.8-0.8 0.8-1.2 0-2.3 0.5-2.3 2.2z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M54.2 9.4c-0.4 0-0.8 0.3-0.8 0.7v7.7c0 0.4 0.4 0.7 0.8 0.7 0.4 0 0.8-0.3 0.8-0.7v-7.7c0-0.4-0.4-0.7-0.8-0.7z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M64.1 10.2c0-0.4 0.4-0.7 0.8-0.7 0.4 0 0.8 0.3 0.8 0.7v7.7c0 0.4-0.4 0.7-0.8 0.7-0.4 0-0.8-0.3-0.8-0.7v-0.4a4.7 4.7 0 0 1-3.1 1.2 4.7 4.7 0 0 1-4.7-4.7c0-2.6 2.1-4.7 4.7-4.7 1.2 0 2.3 0.5 3.1 1.2zm-3.1 7a3.1 3.1 0 0 0 3.1-3.1 3.1 3.1 0 0 0-3.1-3.1 3.1 3.1 0 0 0-3.1 3.1 3.1 3.1 0 0 0 3.1 3.1z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M73.4 13.3c0-1.3-1.1-2.4-2.4-2.4-1.2 0-2.4 0.5-2.4 2.3v4.7c0 0.4-0.4 0.7-0.8 0.7-0.4 0-0.8-0.3-0.8-0.7v-7.7c0-0.4 0.4-0.7 0.8-0.7 0.4 0 0.7 0.3 0.8 0.7 0.7-0.5 1.5-0.8 2.4-0.8 2.1 0 4 1.6 4 3.7v4.8c0 0.4-0.4 0.7-0.8 0.7-0.4 0-0.8-0.3-0.8-0.7z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M18.2 13.8c0-2.4-2.1-4.4-4.7-4.4a4.7 4.7 0 0 0-4.7 4.7c0 2.6 2.1 4.7 4.7 4.7a4.6 4.6 0 0 0 3.3-1.3 0.8 0.8 0 0 0 0.3-0.6 0.8 0.8 0 0 0-0.8-0.8c-0.2 0-0.4 0.1-0.6 0.3-0.5 0.6-1.3 0.8-2.1 0.8-1.6 0-2.8-1.1-3.1-2.5h7.1c0 0 0.1 0 0.1 0a0.9 0.9 0 0 0 0.6-0.8zm-4.7-2.9c1.4 0 2.6 0.9 3 2.2h-6c0.4-1.3 1.6-2.2 3-2.2z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M46 13.8c0-2.4-2.2-4.4-4.7-4.4a4.7 4.7 0 0 0-4.7 4.7c0 2.6 2.1 4.7 4.7 4.7a4.6 4.6 0 0 0 3.3-1.3 0.8 0.8 0 0 0 0.3-0.6 0.8 0.8 0 0 0-0.8-0.8c-0.2 0-0.4 0.1-0.6 0.3-0.5 0.6-1.3 0.8-2.1 0.8-1.6 0-2.8-1.1-3.1-2.5h7.1c0.3-0.1 0.6-0.5 0.6-0.9zm-4.7-2.9c1.4 0 2.6 0.9 3 2.2h-6c0.4-1.3 1.6-2.2 3-2.2z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M76.6 18.6c-0.1 0-0.1-0.1-0.1-0.1v-1.3h-0.3c-0.1 0-0.1-0.1-0.1-0.1 0-0.1 0.1-0.1 0.1-0.1h0.8c0.1 0 0.1 0.1 0.1 0.1 0 0.1-0.1 0.1-0.1 0.1h-0.3v1.3c0 0.1-0.1 0.1-0.1 0.1z"
          style="fill: #26478d; stroke-width: 0.3"
        />
        <path
          d="M78.1 18.6c-0.1 0-0.1-0.1-0.1-0.1l-0.4-1.1v1c0 0.1-0.1 0.1-0.1 0.1-0.1 0-0.1-0.1-0.1-0.1v-1.4a0.2 0.2 0 0 1 0.2-0.2c0.1 0 0.2 0.1 0.2 0.1l0.4 1.1 0.4-1.1a0.2 0.2 0 0 1 0.2-0.1 0.2 0.2 0 0 1 0.2 0.2v1.4c0 0.1-0.1 0.1-0.1 0.1-0.1 0-0.1-0.1-0.1-0.1v-1c-0.1 0.2-0.1 0.4-0.2 0.6-0.1 0.4-0.2 0.4-0.2 0.4 0 0.1 0 0.1-0.1 0.1z"
          style="fill: #26478d; stroke-width: 0.3"
        />
      </svg>
    </a>

    <span class="header-title">{{ appTitle }}</span>
    <router-link
      :to="{ name: 'base-home' }"
      class="eds-primary-nav-item eds-link header-nav-link"
    >
      Home
    </router-link>
    <router-link
      :to="{ name: 'ams-home' }"
      class="eds-primary-nav-item eds-link header-nav-link"
    >
      AMS
    </router-link>
    <router-link
      :to="{ name: 'admin-home' }"
      class="eds-primary-nav-item eds-link header-nav-link"
    >
      Admin
    </router-link>
    <nav class="header-section" aria-label="Utility Navigation">
      <slot name="utilityNav" />
    </nav>
  </header>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PrimaryHeader',
    props: {
      appTitle: {
        type: String,
        required: false,
        default: '',
      },
      /**todo: paasing data initials as prop? */
    },
  });
</script>

<style>
  .eds-primary-header .header-title,
  .eds-primary-header .header-nav-link {
    height: 62px;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: normal;
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
    box-sizing: border-box;
  }
  .eds-primary-header .header-title {
    border-left: 1px solid #ccc;
    padding-left: 16px;
    margin-right: 16px;
  }
  .eds-primary-header .header-nav-link {
    padding-left: 16px;
    padding-right: 16px;
  }
</style>
